import React from "react";
import styles from "./SwitchModeButton.module.css";

const SwitchModeButton = ({ isDisable, handleChange, isChecked }) => {
  return (
    <div
      className={`${styles.toggleContainer} ${
        isDisable ? styles.disableToClick : styles.ableToClick
      }`}
      onClick={() => {
        if (!isDisable) {
          handleChange();
        }
      }}
    >
      <div
        className={`${styles.toggleBtn} ${!isChecked ? styles.disable : ""} ${
          isDisable ? styles.disableToClick : styles.ableToClick
        }`}
      ></div>
      <div
        className={`${isDisable ? styles.disableToClick : styles.ableToClick} ${
          styles.rightText
        } ${isChecked ? styles.opacity : ""} `}
      >
        Auto
      </div>
      <div
        className={`${isDisable ? styles.disableToClick : styles.ableToClick} ${
          styles.leftText
        } ${!isChecked ? styles.opacity : ""} `}
      >
        Manual
      </div>
    </div>
  );
};

export default SwitchModeButton;
